<template>
    <div>
        <div style=" height: calc(100vh - 341px);overflow: auto;">
            <div class="page_box">
                <div class="box_top">
                    <span class="box_title flex_nowrap">最新发帖</span>
                    <span class="box_tab flex_nowrap"
                          @click="changeNew('', -1)"
                          :class="{'tsj': newIndex == -1}">全部</span>
                    <span class="box_tab flex_nowrap"
                          :title="`${item.name}`"
                          @click="changeNew(item.id, index)"
                          :class="{'tsj': newIndex == index}"
                          v-for="(item, index) in msgType.list"
                          v-if="index <= 8">{{item.name}}</span>
                    <router-link tag="span"
                                 v-if="config.menuInfo && config.menuInfo.dateSelect == 1"
                                 class="fr more"
                                 :to="{name: 'searchData', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">MORE</router-link>
                </div>
                <div class="box_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言类型</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">姓名</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">内容</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">发帖时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">更新时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">应回复单位</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言状态</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">回复人</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in newList">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageTypeName}}</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">{{item.userName}}</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">
                                        <a-popover placement="bottom">
                                            <template slot="content">
                                                <p style="max-width: 300px;">{{item.content}}</p>
                                            </template>
                                            {{item.content}}
                                        </a-popover>
                                    </div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.addTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.lastUpdateTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.serviceCentreName}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageState | messageState}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageRelyeUserName || '/'}}</div>
                                </a-col>
                            </a-row>
                            <a-row v-if="newList.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap"
                                         style="height: 100px;line-height: 100px;">无查询结果</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page_box">
                <div class="box_top">
                    <span class="box_title flex_nowrap">最热发帖</span>
                    <span class="box_tab flex_nowrap"
                          @click="changHot('', -1)"
                          :class="{'tsj': hotIndex == -1}">全部</span>
                    <span class="box_tab flex_nowrap"
                          :title="`${item.name}`"
                          @click="changHot(item.id, index)"
                          :class="{'tsj': hotIndex == index}"
                          v-for="(item, index) in msgType.list"
                          v-if="index <= 8">{{item.name}}</span>
                    <router-link tag="span"
                                 v-if="config.menuInfo && config.menuInfo.dateSelect == 1"
                                 class="fr more"
                                 :to="{name: 'searchData', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">MORE</router-link>
                </div>
                <div class="box_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言类型</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">姓名</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">内容</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">发帖时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">更新时间</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">应回复单位</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言状态</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">回复人</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in hotList">
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageTypeName}}</div>
                                </a-col>
                                <a-col :span="2">
                                    <div class="list_data flex_nowrap">{{item.userName}}</div>
                                </a-col>
                                <a-col :span="4">
                                    <div class="list_data flex_nowrap">
                                        <a-popover placement="bottom">
                                            <template slot="content">
                                                <p style="max-width: 300px;">{{item.content}}</p>
                                            </template>
                                            {{item.content}}
                                        </a-popover>
                                    </div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.addTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.lastUpdateTime | timeFormat}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.serviceCentreName}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageState | messageState}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageRelyeUserName || '/'}}</div>
                                </a-col>
                            </a-row>
                            <a-row v-if="hotList.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap"
                                         style="height: 100px;line-height: 100px;">无查询结果</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page_box"
                 style="display: flex;">
                <div class="page_box"
                     style="margin-bottom: 0;min-width: 520px; margin-right: 40px; display: inline-block">
                    <div class="box_top">
                        <span class="box_title flex_nowrap">部门回复效率排名</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': depIndex == -1}"
                              @click="changeDep('year', -1)">本年</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': depIndex == 0}"
                              @click="changeDep('month', 0)">本月</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': depIndex == 1}"
                              @click="changeDep('week', 1)">本周</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': depIndex == 2}"
                              @click="changeDep('day', 2)">昨天</span>
                        <router-link tag="span"
                                     class="fr more"
                                     v-if="config.menuInfo && config.menuInfo.statisticRankingStause == 1 && config.menuInfo.statisticRanking.departReply"
                                     :to="{name: 'rank', params: { schoolcode: Cookies.get('SCHOOLCODE')}}">MORE</router-link>
                    </div>
                    <div class="box_content">
                        <div class="list_content">
                            <!-- 34 200 65  175-->
                            <div>
                                <a-row class="list_border list_title">
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">排名</div>
                                    </a-col>
                                    <a-col :span="10">
                                        <div class="list_data flex_nowrap tl">服务部门</div>
                                    </a-col>
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">回复数</div>
                                    </a-col>
                                    <a-col :span="8">
                                        <div class="list_data flex_nowrap">平均回复时间（小时）</div>
                                    </a-col>

                                </a-row>
                            </div>
                            <div>
                                <a-row v-for="(item, index) in depList"
                                       v-if="index < 7"
                                       :class="{'first': index == 0, 'second': index == 1, 'third': index == 2}">
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">{{index + 1}}</div>
                                    </a-col>
                                    <a-col :span="10">
                                        <div class="list_data flex_nowrap tl">{{item.departmentName}}</div>
                                    </a-col>
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">{{item.replyNum}}</div>
                                    </a-col>
                                    <a-col :span="8">
                                        <div class="list_data flex_nowrap">{{item.aveReply.toFixed(2)}}</div>
                                    </a-col>
                                </a-row>
                                <a-row v-if="depList.length == 0">
                                    <a-col :span="24">
                                        <div class="list_data flex_nowrap"
                                             style="height: 100px;line-height: 100px;">无查询结果</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page_box"
                     style="margin-bottom: 0;min-width: 520px; display: inline-block">
                    <div class="box_top">
                        <span class="box_title flex_nowrap">服务中心点赞数排名</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': serIndex == -1}"
                              @click="changeSer('year', -1)">本年</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': serIndex == 0}"
                              @click="changeSer('month', 0)">本月</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': serIndex == 1}"
                              @click="changeSer('week', 1)">本周</span>
                        <span class="box_tab flex_nowrap"
                              :class="{'tsj': serIndex == 2}"
                              @click="changeSer('day', 2)">昨天</span>
                        <router-link tag="span"
                                     class="fr more"
                                     v-if="config.menuInfo && config.menuInfo.statisticRankingStause == 1 && config.menuInfo.statisticRanking.serviceCenterLike"
                                     :to="{name: 'rank', query: {query: 1}, params: { schoolcode: Cookies.get('SCHOOLCODE')}}">MORE</router-link>
                    </div>
                    <div class="box_content">
                        <div class="list_content">
                            <div>
                                <a-row class="list_border list_title">
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">排名</div>
                                    </a-col>
                                    <a-col :span="17">
                                        <div class="list_data flex_nowrap tl">服务中心</div>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="list_data flex_nowrap">获赞次数</div>
                                    </a-col>

                                </a-row>
                            </div>
                            <div>
                                <a-row v-for="(item, index) in serList"
                                       v-if="index < 7"
                                       :class="{'first': index == 0, 'second': index == 1, 'third': index == 2}">
                                    <a-col :span="3">
                                        <div class="list_data flex_nowrap">{{index + 1}}</div>
                                    </a-col>
                                    <a-col :span="17">
                                        <div class="list_data flex_nowrap tl">{{item.serviceCentreName}}</div>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="list_data flex_nowrap">{{item.thumbsNum}}</div>
                                    </a-col>
                                </a-row>
                                <a-row v-if="serList.length == 0">
                                    <a-col :span="24">
                                        <div class="list_data flex_nowrap"
                                             style="height: 100px;line-height: 100px;">无查询结果</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page_box"
                 style="overflow: hidden;">
                <div class="box_top border_none">
                    <span class="box_title">留言类型排名</span>
                    <router-link tag="span"
                                 class="fr more"
                                 v-if="config.menuInfo && config.menuInfo.typeStatistic.messageType == 1"
                                 :to="{name: 'statistics'}">MORE</router-link>
                </div>
                <div style="display: flex">
                    <div class="small_box"
                         v-for="(item, index) in MsgTypeList"
                         v-if="index < 4">
                        <div class="small_box_top">
                            <div class="small_box_bg"
                                 :class="{
                        'level_1': item.level == 1,
                        'level_2': item.level == 2,
                        'level_3': item.level == 3,
                        'level_0': item.level == 0,
                    }">
                                {{item.name}}
                            </div>
                        </div>
                        <div class="list_content">
                            <div>
                                <a-row class="list_border list_title">
                                    <a-col :span="5">
                                        <div class="list_data flex_nowrap">排名</div>
                                    </a-col>
                                    <a-col :span="14">
                                        <div class="list_data flex_nowrap tl">服务中心</div>
                                    </a-col>
                                    <a-col :span="5">
                                        <div class="list_data flex_nowrap">留言数</div>
                                    </a-col>
                                </a-row>
                            </div>
                            <div>
                                <a-row v-for="(val, i) in item.list"
                                       v-if="i < 7">
                                    <a-col :span="5">
                                        <div class="list_data flex_nowrap">{{i + 1}}</div>
                                    </a-col>
                                    <a-col :span="14">
                                        <div class="list_data flex_nowrap tl">{{val.serviceCenterName}}</div>
                                    </a-col>
                                    <a-col :span="5">
                                        <div class="list_data flex_nowrap">{{val.messageNum}}</div>
                                    </a-col>
                                </a-row>
                                <a-row v-if="item.list.length == 0">
                                    <a-col :span="24">
                                        <div class="list_data flex_nowrap"
                                             style="height: 100px;line-height: 100px;">无查询结果</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import getTme from "../common/time";
import { mapGetters } from "vuex";
import moment from "moment";
import Cookies from "js-cookie";
export default {
    computed: {
        ...mapGetters(["msgType", "config"])
    },
    created() {
        this.changeNew("", -1);
        this.changHot("", -1);
        this.changeDep("year", -1);
        this.changeSer("year", -1);
        this.getMsgTypeList();
    },
    data() {
        return {
            Cookies,
            newList: [],
            newIndex: -1,
            hotList: [],
            hotIndex: -1,
            depList: [],
            depIndex: -1,
            serList: [],
            serIndex: -1,
            MsgTypeList: []
        };
    },
    methods: {
        changeNew(id, index) {
            this.newIndex = index;
            this.$api
                .getMsgList({
                    "page.pageSize": 7,
                    "page.pageNum": 1,
                    "page.sort": "add_time",
                    "page.order": "desc",
                    messageTypeId: id
                })
                .then(res => {
                    this.newList = res.param.page.rows;
                });
        },

        changHot(id, index) {
            this.hotIndex = index;
            this.$api
                .getMsgList({
                    "page.pageSize": 7,
                    "page.pageNum": 1,
                    "page.sort": "thumbs_number",
                    "page.order": "desc",
                    messageTypeId: id,
                    addStartTime: "2018-01-01",
                    addEndTime: moment()
                        .subtract(1, "days")
                        .format("YYYY-MM-DD")
                })
                .then(res => {
                    this.hotList = res.param.page.rows;
                });
        },
        changeDep(time, index) {
            this.depIndex = index;
            if (getTme[time]()) {
                this.$api
                    .getDepList({
                        startTime: getTme[time]()[0],
                        endTime: getTme[time]()[1]
                    })
                    .then(res => {
                        res.param.list.forEach(item => {
                            item.aveReply = item.waitTime / item.replyNum;
                        });

                        res.param.list.sort((a, b) => {
                            return a.aveReply - b.aveReply;
                        });

                        this.depList = res.param.list;
                    });
            } else {
                this.depList = [];
            }
        },
        changeSer(time, index) {
            this.serIndex = index;
            if (getTme[time]()) {
                this.$api
                    .getSerList({
                        startTime: getTme[time]()[0],
                        endTime: getTme[time]()[1]
                    })
                    .then(res => {
                        this.serList = res.param.list;
                    });
            } else {
                this.serList = [];
            }
        },
        getMsgTypeList() {
            this.$api.getMsgTypeList().then(res => {
                this.MsgTypeList = res.param.list;
            });
        }
    },
    filters: {
        messageState(val) {
            if (val == 0) {
                return "待回复";
            } else if (val == 1) {
                return "已回复";
            } else if (val == 2) {
                return "已关闭";
            } else if (val == 3) {
                return "已退回";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.small_box {
    float: left;
    width: 250px;
    height: 320px;
    margin-right: 26px;
    box-shadow: #b4b4b4 0 0 5px;
    margin-bottom: 30px;

    .small_box_top {
        border-radius: 4px;
        border: 2px solid white;
        // background-color: rgba(0, 0, 0, 0.3);
    }

    .small_box_bg {
        margin-top: 9px;
        color: #fff;
        font-size: 16px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        width: 260px;
        margin-left: -5px;
    }
}
.small_box:last-child {
    margin-right: 0;
}
.first {
    background-color: #d8eaff;
}
.second {
    background-color: #fff9d3;
}
.third {
    background-color: #f1ffd3;
}

.box_content {
    height: 270px;
}

.level_1 {
    background: #1890ff;
}
.level_2 {
    background: #faad14;
}
.level_3 {
    background: #f62e39;
}
.level_0 {
    background: #4bcc72;
}
</style>